import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const session_detailScreenModule = defineScreen({
  app: "coaching",
  screen_id: "session-detail",
  path: "/sessions/:session_id",
  params: ["session_id"],
  heading: { text: "Session detail", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "allow",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "detail.load" }
  ],
  recipe: "Detail-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/session-detail.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default session_detailScreenModule;
